"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSchema = validateSchema;
const aggregateFunction_1 = require("./aggregateFunction");
const calcFunction_1 = require("./calcFunction");
const defaultValue_1 = require("./defaultValue");
const defineSchema_1 = require("./defineSchema");
const fixAndMergeSchema_1 = require("./fixAndMergeSchema");
const schemaPath_1 = require("./schemaPath");
const schemaValue_1 = require("./schemaValue");
const validFunction_1 = require("./validFunction");
const validPropFunction_1 = __importDefault(require("./validPropFunction"));
const schemaMethods = __importStar(require("../schemaMethods"));
const functions_1 = require("../WrappedProperty/functions");
const dynamicNumberRules = [
    'maxLength',
    'minLength',
    'maxItems',
    'minItems',
    'minimum',
    'maximum',
    'exclusiveMaximum',
    'exclusiveMinimum'
];
function _validateSchema(schema, data, parent, key, $external, result) {
    const obj = {};
    obj.$key = key;
    obj.$model = data;
    obj.$parent = parent;
    if (parent === null) {
        obj.$root = obj;
    }
    else {
        obj.$root = parent.$root;
    }
    if (data === undefined) {
        data = (0, defaultValue_1.defaultValue)(schema, true, 0);
    }
    //const paramData: any[] = [obj.$root.$model, {}, {}, {}, $external, schemaMethods, obj];
    const paramCtx = {
        $root: obj.$root.$model,
        $parent: {},
        $parent2: {},
        $parent3: {},
        $external,
        $methods: schemaMethods,
        $obj: obj
    };
    if (parent) {
        paramCtx.$parent = parent.$model;
        if (parent.parent) {
            paramCtx.$parent2 = parent.parent.$model;
            if (parent.parent.parent) {
                paramCtx.$parent3 = parent.parent.parent.$model;
            }
        }
    }
    if (schema.type === 'object') {
        // tslint:disable-next-line: forin
        for (const key2 in schema.properties) {
            const value = data[key2];
            _validateSchema(schema.properties[key2], value, obj, key2, $external, result);
        }
    }
    else if (schema.type === 'array') {
        if (Array.isArray(data)) {
            _validateSchema(schema.items, data[0], obj, 0, $external, result);
        }
    }
    // `$root,$parent,$parent2,$parent3,$external,$methods,$obj`;
    if (schema.aggregate) {
        const func = (0, aggregateFunction_1.aggregateFunction)(schema, false);
        if (func) {
            try {
                const aggresult = func.call(parent.$model, paramCtx);
                if (isNaN(aggresult)) {
                    result.push({
                        path: (0, schemaPath_1.schemaPath)(obj),
                        err: 'isNaN',
                        method: 'aggregate'
                    });
                }
            }
            catch (err) {
                result.push({
                    path: (0, schemaPath_1.schemaPath)(obj),
                    err,
                    method: 'aggreagate'
                });
            }
        }
    }
    if (schema.calc) {
        const func = (0, calcFunction_1.calcFunction)(schema, false, false, true);
        try {
            let thisModel = parent.$model;
            if ((0, defineSchema_1.isFunction)(schema.calc)) {
                thisModel = (0, functions_1.createCtxProxy)({ options: {}, parent: parent.$model, calcCtx: paramCtx });
            }
            const aggresult = func.call(thisModel, paramCtx);
            const typerr = _resError(schema.type, aggresult);
            if (typerr) {
                result.push({
                    path: (0, schemaPath_1.schemaPath)(obj),
                    err: typerr,
                    method: 'calc'
                });
            }
        }
        catch (err) {
            result.push({
                path: (0, schemaPath_1.schemaPath)(obj),
                err,
                method: 'calc'
            });
        }
    }
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < dynamicNumberRules.length; i++) {
        const field = dynamicNumberRules[i];
        if (schema[field] !== undefined) {
            if (typeof schema[field] !== 'number') {
                const func = (0, validPropFunction_1.default)(schema[field]);
                try {
                    const validres = func.call(parent.$model, paramCtx);
                    const typerr = _resError('number', validres);
                    if (typerr) {
                        result.push({
                            path: (0, schemaPath_1.schemaPath)(obj),
                            err: typerr,
                            method: field
                        });
                    }
                }
                catch (err) {
                    result.push({
                        path: (0, schemaPath_1.schemaPath)(obj),
                        err,
                        method: field
                    });
                }
            }
        }
    }
    if (schema.fieldRequired) {
        if (typeof schema.fieldRequired !== 'boolean') {
            const func = (0, validPropFunction_1.default)(schema.fieldRequired);
            try {
                const validres = func.call(parent.$model, paramCtx);
                const typerr = _resError('boolean', validres);
                if (typerr) {
                    result.push({
                        path: (0, schemaPath_1.schemaPath)(obj),
                        err: typerr,
                        method: 'fieldRequired'
                    });
                }
            }
            catch (err) {
                result.push({
                    path: (0, schemaPath_1.schemaPath)(obj),
                    err,
                    method: 'fieldRequired'
                });
            }
        }
    }
    if (schema.validFunc) {
        const func = (0, validFunction_1.validFunction)(schema, schema.validFunc, false);
        try {
            const aggresult = func.call(parent.$model, paramCtx);
            if (aggresult !== null && typeof aggresult !== 'boolean') {
                const typerr = _resError('string', aggresult);
                if (typerr) {
                    result.push({
                        path: (0, schemaPath_1.schemaPath)(obj),
                        err: typerr,
                        method: 'validFunc'
                    });
                }
            }
        }
        catch (err) {
            result.push({
                path: (0, schemaPath_1.schemaPath)(obj),
                err,
                method: 'validFunc'
            });
        }
    }
}
function _resError(type, res) {
    if (type === 'number' || type === 'money' || type === 'integer') {
        if (isNaN(res)) {
            return 'isNan';
        }
        else if (typeof res !== 'number') {
            return 'notNumber: ' + typeof res;
        }
    }
    else if (type === 'string') {
        // nothing
    }
    else if (type === 'array') {
        if (!Array.isArray(res)) {
            return 'notArray: ' + typeof res;
        }
    }
    else if (type === 'object') {
        if (typeof res !== 'object') {
            return 'notObject: ' + typeof res;
        }
    }
    return '';
}
function validateSchema(schema, path, data, $external) {
    let schema2 = schema;
    if (schema.$parent === undefined) {
        schema2 = (0, fixAndMergeSchema_1.fixAndMergeSchema)([schema]);
    }
    if (path) {
        const schema3 = (0, schemaValue_1.schemaValue)(schema2, path);
        if (schema3 !== null) {
            schema2 = schema3;
        }
        else {
            throw new Error('Invalid schema path');
        }
    }
    if ($external === undefined) {
        $external = {};
    }
    if (data === undefined) {
        data = (0, defaultValue_1.defaultValue)(schema2, true, 0);
    }
    const result = [];
    _validateSchema(schema2, data, null, null, $external, result);
    return result;
}
exports.default = validateSchema;
//# sourceMappingURL=validateSchema.js.map